import styled from "styled-components";

import SearchForm, { SearchField } from "../../../components/design/layout/search";

export const Form = styled(SearchForm)`
    flex-direction: row;
    padding-right: 0;
    padding-left: 15px;

    input[type=text],
    input[type=search],
    button[type=submit] {
        height: 38px
    }
`;

export const Field = styled(SearchField)`
    height: 38px !important;
`;

export const WrapperContent = styled.div`
    position: fixed;
    top: 62px;
    left: 0;
    right: 0;
    width: 100%;
    height: 100%;
    z-index: 997;
    overflow: scroll;
    overscroll-behavior: contain;
    padding-bottom: 6.625rem;
    background-color: ${({ theme }) => theme.color.white};
`;

export const LocationSelected = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-start;
    border: 0.0625rem solid ${({ theme }) => theme.color.light};
    border-radius: 0.375rem;
    padding: 2px 0.9375rem;
`;

export const Column = styled.div`
    svg {
        height: 18px;
        width: auto !important;

        path {
            fill: ${({ theme }) => theme.color.red};
        }
    }

    &:first-child {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        width: 100%;
        
        .Wrapper {
            margin-left: 0.625rem;
        }
    }

    &:last-child {
        svg {
            height: 14px;
            width: auto !important;

            path {
                fill: ${({ theme }) => theme.color.gray};
            }
        }
    }
`;

export const Desc = styled.div`
`;

export const Title = styled.div`
    font-size: 0.75rem;
    font-weight: ${({ theme }) => theme.fontWeight.fw600};
    color: ${({ theme }) => theme.color.grayBold}
`;

export const StateSelectedTitle = styled(Title)`
    font-size: 0.875rem;
    font-weight: ${({ theme }) => theme.fontWeight.fw700};
    text-transform: capitalize;
`;
